import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { filterBySalary, searchByKeyword } from '../features/filter/filterSlice'

export default function Header() {
    const dispatch = useDispatch()
    const [keyword, setKeyword] = useState("")

    function handleChange(e) {
        setKeyword(e.target.value)
        dispatch(searchByKeyword(e.target.value))
    }

    function filterJobsBySalary(value) {
        dispatch(filterBySalary(value))
    }

    return (
        <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
            <h1 className="lws-section-title">All Available Jobs</h1>
            <div className="flex gap-4">
                <div className="search-field group flex-1">
                    <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
                    <input type="text" placeholder="Search Job" value={keyword} onChange={e => handleChange(e)} className="search-input" id="lws-searchJob" />
                </div>
                <select onChange={e => filterJobsBySalary(e.target.value)} id="lws-sort" name="sort" autoComplete="sort" className="flex-1">
                    <option value="">Default</option>
                    <option value="lowTohigh">Salary (Low to High)</option>
                    <option value="highTolow">Salary (High to Low)</option>
                </select>
            </div>
        </div>
    )
}
